import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _2baa3428 = () => import('../pages/about.vue' /* webpackChunkName: "pages/about" */).then(m => m.default || m)
const _214069b5 = () => import('../pages/confirm-registration-page.vue' /* webpackChunkName: "pages/confirm-registration-page" */).then(m => m.default || m)
const _24e7eb43 = () => import('../pages/jury.vue' /* webpackChunkName: "pages/jury" */).then(m => m.default || m)
const _17140268 = () => import('../pages/previous.vue' /* webpackChunkName: "pages/previous" */).then(m => m.default || m)
const _6209d2b3 = () => import('../pages/request-form.vue' /* webpackChunkName: "pages/request-form" */).then(m => m.default || m)
const _797519a2 = () => import('../pages/reset-password-page.vue' /* webpackChunkName: "pages/reset-password-page" */).then(m => m.default || m)
const _983f0234 = () => import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */).then(m => m.default || m)
const _1b36bdbc = () => import('../pages/user.vue' /* webpackChunkName: "pages/user" */).then(m => m.default || m)
const _09e2c0b1 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)
const _62c59f80 = () => import('../pages/-participants-page.vue' /* webpackChunkName: "" */).then(m => m.default || m)
const _53b03752 = () => import('../pages/-participant.vue' /* webpackChunkName: "" */).then(m => m.default || m)
const _a76c0a28 = () => import('../layouts/error.vue' /* webpackChunkName: "" */).then(m => m.default || m)



const scrollBehavior = function(to, from, savedPosition) {
      if (to.path === '/participants-page' && savedPosition) {
        return savedPosition
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/about",
			component: _2baa3428,
			name: "about"
		},
		{
			path: "/confirm-registration-page",
			component: _214069b5,
			name: "confirm-registration-page"
		},
		{
			path: "/jury",
			component: _24e7eb43,
			name: "jury"
		},
		{
			path: "/previous",
			component: _17140268,
			name: "previous"
		},
		{
			path: "/request-form",
			component: _6209d2b3,
			name: "request-form"
		},
		{
			path: "/reset-password-page",
			component: _797519a2,
			name: "reset-password-page"
		},
		{
			path: "/terms",
			component: _983f0234,
			name: "terms"
		},
		{
			path: "/user",
			component: _1b36bdbc,
			name: "user"
		},
		{
			path: "/",
			component: _09e2c0b1,
			name: "index"
		},
		{
			path: "/participants-page",
			component: _62c59f80
		},
		{
			path: "/participants-page/:id",
			component: _53b03752
		},
		{
			path: "*",
			component: _a76c0a28
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js